module.exports = __webpack_public_path__ + "img/age-1.161da957.png";